module.exports = __webpack_public_path__ + "img/admin.b416be1c.png";